import type { ReactNode } from 'react';
import { cn } from '@/lib/ui/utils';

interface UnavailableWalletBadgeProps {
  label: string;
  className?: string;
}

export function UnavailableWalletBadge({
  label,
  className,
}: UnavailableWalletBadgeProps): ReactNode {
  return (
    <span
      className={cn(
        'inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden whitespace-nowrap rounded-pill border border-border-primary px-2 py-0.5 text-caption font-medium text-foreground-primary',
        className,
      )}
    >
      {label}
    </span>
  );
}
